<template>
  <v-app class="all">
    <!-- add the class .homepage to enable background -->
    <v-main class="homepage"> 
      <Nav></Nav>
      <router-view></router-view>
      <Footer></Footer>
    </v-main>
  </v-app>
</template>

<script>
import Nav from '@/components/Nav.vue'; // Ensure correct import path
import Footer from '@/components/Footer.vue'; // Ensure correct import path


export default {
  name: 'App',

  components: {
    Nav,
    Footer
  },

  data: () => ({
    //
  }),
};
</script>

<style scoped>
.homepage {
  background: url('@/assets/images/rizal_live_background.jpg') no-repeat center center fixed;
  background-size: cover; /* Ensures the image covers the whole page */
  background-position: center; /* Centers the image */
  background-repeat: no-repeat; /* Prevents tiling */
  overflow-x: hidden;
}
</style>
